<template>
    <div class="px-3 py-2 space-y-2">
        <div class="grid md:grid-cols-2 md:items-center">
            <div>
                <h2 class="text-lg font-semibold">
                    {{ lang('events::events.dashboards.upcoming') }}
                </h2>
            </div>
            <div class="md:flex md:justify-end">
                <inertia-link
                    :href="route('events.admin.index')"
                    class="inline-flex items-center space-x-2 text-xs font-semibold underline uppercase hover:no-underline"
                >
                    <span>
                        {{ lang('events::events.actions.manage') }}
                    </span>
                    <icon icon="hero/outline/chevron-right" class="size-4"></icon>
                </inertia-link>
            </div>
        </div>
        <EventPreview v-for="event in events" :key="event.id" :event="event"></EventPreview>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import EventPreview from '@src/Events/Pages/Preview.vue';

const { props } = usePage();

const page = ref(props.components[1] ?? null);

const events = ref(page.value.events ?? []);
</script>
